exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-3a74bd26]{margin:0;padding-left:1rem}.wrap[data-v-3a74bd26]{word-wrap:break-word;word-break:break-all;white-space:normal}", ""]);

// exports
